import React from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Section from "../../common/Section";
import Fieldset from "../../common/Fieldset";
import TextAreaInput from "../../common/TextAreaInput";
import Row from "../../common/Row";

const AndereOpmerkingenForm = (props) => {
    const {
        goToNext,
        goToPrev,
        model,
        onChange,
        andereOpmerkingHasFocus
    } = props;

    return (
        <Section>
            <Form
                name="andereOpmerkingen"
                headerVisible={false}
                isNotRequired
                rightButtonLabel="Ga verder"
                leftButtonLabel="Terug"
                onRightButtonClick={goToNext}
                onLeftButtonClick={goToPrev}
            >
                <Fieldset>
                    <Row><div style={{ color: "#082b42", fontSize: "1.4375rem", fontWeight: "500", lineHeight: "28px", margin: "30px 0.83333% 0 0.83333%" }}>Andere opmerkingen</div></Row>
                </Fieldset>
                <div style={{ width: "100%", height: "1px", backgroundColor: "#E6E6E6", marginTop: "30px" }}></div>
                <Fieldset>
                    <Row>
                        <TextAreaInput
                            name="opmerking"
                            label="Andere opmerkingen"
                            value={model.opmerking}
                            onChange={onChange}
                            size={12}
                            optional
                            hasFocus={andereOpmerkingHasFocus}
                        />
                    </Row>
                </Fieldset>
            </Form>
        </Section>
    );
};

AndereOpmerkingenForm.propTypes = {
    goToNext: PropTypes.func,
    goToPrev: PropTypes.func,
    model: PropTypes.object,
    andereOpmerkingHasFocus: PropTypes.bool,
    onChange: PropTypes.func
};

export default AndereOpmerkingenForm;